import React, { useState, useRef, useEffect } from "react"
import WmCards from "../ui-components/wmcards/WmCards";
import WmModals from "../modals/Wm.Modals";
import API_ENDPOINT from "../wm.api.service";
import axios from "axios";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { decode } from "base-64";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Required from "../Components/required/Required";
import Moment from "react-moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { wordCountFun } from '../functions/general'
import dummy from "../assets/images/file.svg";
import Cookies from "universal-cookie";
import { useQueryClient, useMutation } from "react-query";
import { ExclamationIcon } from "@heroicons/react/outline";
import Spinner from "../Components/spinner/Spinner";
import { getSinglePortfolioDetail, updateWorkData } from "../functions/details";
import ServerError from "../Pages/error/500/ServerError";
const Cookie = new Cookies();
function Workcard({ workData }) {
  const queryClient = useQueryClient()
  var token = Cookie.get("wmtoken");
  const [workModal, setWorkModal] = React.useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const [portfolioData, setPortfolioData] = useState({ title: '', company: '', emp_type: '', work_description: '', start_date: '', end_date: '', media_privacyBool: true, media_privacy: 0, mediaSend: '', media: dummy, currently_working: false });
  const bioWordCount = (words) => {
    setWordCount(words.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {
      setCountBool(true);
    }
    if (!wordCountFun(words, maxLength)) {
      setCountBool(false);
    }
  };
  useEffect(() => {
    bioWordCount(portfolioData.work_description)
  }, [])
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteFeild = (e, id) => {
    setIsDeleting(true);
    e.preventDefault();
    var fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("field_name", "WORK");
    fd.append("field_id", id);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
      data: fd,
    })
      .then(function () {
        queryClient.invalidateQueries('workData')
        setIsDeleting(false);
        setWorkModal(false);
        setIsDeleteModalOpen(false);
      })
      .catch(function (err) {
        setIsDeleting(false);
        alert(err.response.data.validation_error.replace(/(<([^>]+)>)/gi, ""));
      });
  };
  const [deleteModal, setIsDeleteModalOpen] = useState(false);
  const imageDelete = (action) => {
    setPortfolioData((prevData) => {
      prevData.media = null
      prevData.mediaSend = null
      return { ...prevData }
    })
  };
  const fetchSingleData = useMutation((documentId) => getSinglePortfolioDetail('WORK', documentId), {
    onSuccess: (data) => {
      setPortfolioData({
        identity: data.identity, title: data.work_title, company: data.work_company, emp_type: data.employment_type, work_description: data.description, start_date: data.start_date, end_date: data.end_date, media_privacy: data.media_privacy === '1' ? true : false, mediaSend: data.work_media && data.work_media, media: data.work_media, currently_working: data.currently_working === '1' ? true : false
      })
      setWorkModal(true);
    },
  })
  const updateWork = useMutation((data) => updateWorkData(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('workData')
      const previousValue = queryClient.getQueriesData('workData')
      return previousValue
    },
    onError: (err, previousValue) => {
      queryClient.setQueryData('workData', previousValue)
    },
    onSuccess: () => {
      queryClient.invalidateQueries('workData')
      setWorkModal(false)
    }
  })
  return (
    <React.Fragment>
      {fetchSingleData.isLoading ? "Fetching Data....." : (
        <WmCards>
          <div className="educationCard shadow space-y-1 relative p-6 cursor-pointer h-full" onClick={(e) => fetchSingleData.mutate(workData.identity)}>
            <div className="flex justify-between">
              <span className="text-base md:text-xl text-gray-700 inline-block capitalize" style={{"color":"var(--color-5)"}}>{workData.work_company}</span>
              <span className="text-xs italic text-gray-600">
                <Moment format={"YYYY"}>{workData.start_date}</Moment> - {workData.end_date === null || workData.currently_working === "1" ? "Present" : <Moment format={"YYYY"}>{workData.end_date}</Moment>}
              </span>
            </div>
            <div className="flex justify-between">
              <span className='text-sm text-gray-700 inline-block'>{workData.employment_type}</span>
            </div>
            <div className='flex justify-end'>
              {workData.media_privacy === "1" ? (
                workData.work_media === null ? "" : (
                  <div className="media_wrapper w-24 h-24 rounded overflow-hidden ring-1 ring-gray-300">
                    <img src={workData.work_media} alt="media" className="w-full h-full object-cover" />
                  </div>
                )
              ) : (
                ""
              )}
            </div>
          </div>
        </WmCards>
      )}
      <WmModals show={workModal} onHide={() => setWorkModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Update Work Experience</h5>
        {updateWork.isError ? <><div><ServerError message={updateWork.error.response.status} /> <div className="text-center manpro mt-4"><Wmbutton label="Cancel" onClick={() => setWorkModal(false)} className="rounded w-20 mr-2" type="button" color="primary" /></div> </div></>
          : <form onSubmit={(e) => { e.preventDefault(); updateWork.mutate(portfolioData) }}>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Work Title <Required /></label>
              <input type="text" name="title" placeholder="Work Title" className="wm_form_input border-bottom border-gray-300" required value={portfolioData.title} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.title = e.target.value; return { ...prevData } }) }} />
            </div>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Company</label>
              <input type="text" placeholder="Company" name="company" className="wm_form_input border-bottom border-gray-300" required value={portfolioData.company} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.company = e.target.value; return { ...prevData } }) }} />
            </div>
            <div className="wm_form_group flex flex-col mb-4">
              <label className="wm_form_label">Employement Title <Required /></label>
              <select className="selectWm border-bottom border-gray-300" required value={portfolioData.emp_type} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.emp_type = e.target.value; return { ...prevData } }) }}>
                <option value="">--Select---</option>
                <option value="Part-Time">Part-Time</option>
                <option value="Full-Time">Full-Time</option>
                <option value="On Contract">On Contract</option>
                <option value="Freelancer">Freelancer</option>
              </select>
            </div>
            <Row>
              <Col md={12}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Work Description</label>
                  <textarea name="description" placeholder="Work Description" className="wm_form_input border-bottom border-gray-300" onKeyUp={(e) => bioWordCount(e.target.value)} maxLength="150" value={portfolioData.work_description} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.work_description = e.target.value; return { ...prevData } }) }}></textarea>
                  <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>{wordCount}/15</small>
                </div>
              </Col>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Start Date<Required /></label>
                  <DatePicker selected={new Date(portfolioData.start_date)} onChange={(date) => { setPortfolioData((prevData) => { prevData.start_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
                </div>
              </Col>
              <Col md={6}>
                <div className="wm_form_group flex flex-col mb-4">
                  {portfolioData.currently_working ? <span className="manpro font-semibold text-lg text-gray-500">Currently working</span> : <>
                    <label className="wm_form_label">End Date<Required /></label>
                    <DatePicker selected={new Date(portfolioData.end_date)} onChange={(date) => { setPortfolioData((prevData) => { prevData.end_date = date; return { ...prevData } }) }} dateFormat="MM/yyyy" placeholderText="mm - yyyy" className="wm_form_input border-bottom border-gray-300 w-full" showMonthYearPicker showFullMonthYearPicker showFourColumnMonthYearPicker required />
                  </>}
                </div>
              </Col>
              <Col md={12}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Currently Ongoing</label>
                  <Wmswitch color="success" checked={portfolioData.currently_working} onChange={() => setPortfolioData((prevData) => { prevData.currently_working = !portfolioData.currently_working; return { ...prevData } })} />
                </div>
              </Col>
              <Col md={7}>
                <div className="wm_form_group flex mb-4 items-center">
                  <div className="flex flex-col mr-4">
                    <label className="wm_form_label">Media</label>
                    <input type="file" name="grade" className="hidden" accept="image/png, image/jpeg, image/jpg" onChange={(e) => uploadImage(e)} ref={fileUpload} />
                    <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                      {portfolioData.media && portfolioData.media !== "DELETE" ? <img className="object-cover" src={portfolioData.media} alt="education" /> : <img className="object-cover" src={dummy} alt="education" />}
                    </div>
                  </div>
                  <div>
                    <div>
                      <Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right">
                        <HelpIcon />
                      </Tooltip>
                    </div>
                    <div>
                      {portfolioData.media && <DeleteForeverIcon className="cursor-pointer" onClick={() => imageDelete("DELETE")} />}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={5}>
                <div className="wm_form_group flex flex-col mb-4">
                  <label className="wm_form_label">Show Media</label>
                  <Wmswitch color="success" checked={portfolioData.media_privacy} onChange={() => setPortfolioData((prevData) => { prevData.media_privacy = !portfolioData.media_privacy; return { ...prevData } })} />
                </div>
              </Col>
            </Row>
            <div className="wm_form_group">
              <Wmbutton label={updateWork.isLoading ? <CircularProgress className="loader_size_xsm" /> : "Update"} bordered className="rounded w-20 mr-2" type="submit" color="primary-border" />
              <Wmbutton label="Cancel" onClick={() => setWorkModal(false)} className="rounded w-20 mr-2" type="button" color="primary" />
              <Wmbutton label="Delete" onClick={(e) => { setIsDeleteModalOpen(true); setWorkModal(false); }} className="rounded w-20" type="button" color="danger" />
            </div>
          </form>}
      </WmModals>
      <WmModals show={deleteModal} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
        <div className='px-10 py-4'>
          <div>
            <p className='text-center text-xl font-semibold text-gray-700 manpro'>Delete Work experience?</p>
            <div className=' bg-red-100 rounded border-l-2 border-red-700 my-10'>
              <div className='flex space-x-3 p-4'>
                <div>
                  <ExclamationIcon className='w-6 text-red-600' />
                </div>
                <div>
                  <p className='manpro text-red-800 mb-0 font-semibold'>Warning</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>Are you sure you want to delete?</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>You can't undo this action.</p>
                </div>
              </div>
            </div>
            <div className='text-center space-x-3 flex justify-center'>
              <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => { setIsDeleteModalOpen(false); setWorkModal(true); }}>Cancel</button>
              {isDeleting ? <div className='relative flex items-center justify-center'><Spinner className="" width={20} height={20} /></div> : <button className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={(e) => { deleteFeild(e, workData.identity); }}>Delete work experience</button>}
            </div>
          </div>
        </div>
      </WmModals>
    </React.Fragment>
  );
}
export default Workcard;
